import { createTheme } from "@mui/material/styles";

// Light Theme
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#ffffff",
      paper: "#f5f5f5",
    },
    custom: {
      darkerBackground: "#e0e0e0",
    },
    text: {
      primary: "#000000",
      secondary: "#4f4f4f",
    },
    hoverBottomLine: "#22C55E",
  },
});

// Dracula (Dark Theme)
export const draculaTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#BD93F9",
    },
    secondary: {
      main: "#FF79C6",
    },
    background: {
      default: "#282A36",
      paper: "#1E1F29",
    },
    custom: {
      darkerBackground: "#1c1d24",
    },
    text: {
      primary: "#F8F8F2",
      secondary: "#BD93F9",
    },
    divider: "#44475A",
  },
});

export const getTheme = (mode) => {
  // Normalize mode to lowercase before comparison
  const normalizedMode = mode.toLowerCase();

  return normalizedMode === "dark" ? draculaTheme : lightTheme;
};
